import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: December 15, 2025</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            At Tuple Camp, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and purchase our products.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <p><strong>Personal Information</strong></p>
          <ul>
            <li>Name (optional)</li>
            <li>Email address</li>
            <li>Payment information (processed securely via Cashfree)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information for the following purposes:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Send you product access links and instructions</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Send important updates about your purchases</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
            <li>Prevent fraudulent transactions</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Payment Processing</h2>
          <p>
            All payment transactions are processed through Cashfree, a secure third-party payment gateway. We do not store or have access to your credit card details, bank account information, or other sensitive payment data. Cashfree's privacy policy governs the collection and use of your payment information.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Data Storage and Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Sharing and Disclosure</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
          </p>
          <ul>
            <li>With Cashfree for payment processing</li>
            <li>With email service providers for sending course materials</li>
            <li>When required by law or to respond to legal processes</li>
            <li>To protect our rights, privacy, safety, or property</li>
            <li>With your explicit consent</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your browsing experience and analyze website traffic. You can control cookie preferences through your browser settings. Disabling cookies may limit certain features of our website.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites (such as Google Drive for content delivery). We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Your Rights</h2>
          <p>You have the following rights regarding your personal information:</p>
          <ul>
            <li><strong>Access:</strong> Request a copy of your personal data</li>
            <li><strong>Correction:</strong> Request corrections to inaccurate information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal data (subject to legal requirements)</li>
            <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
          </ul>
          <p>
            To exercise these rights, please contact us at <a href="mailto:support@tuplecamp.com">support@tuplecamp.com</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a minor, please contact us immediately for removal.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, comply with legal obligations, resolve disputes, and enforce our agreements. Purchase records are maintained for accounting and tax purposes as required by law.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by updating the "Last updated" date at the top of this policy.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:
          </p>
          <ul>
            <li>Email: <a href="mailto:support@tuplecamp.com">support@tuplecamp.com</a></li>
            <li>Location: Pondicherry, Pondicherry, India</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage;
